import { DateFormat } from '@celito.clients/enums';
import { createTestAttribute, getZonedBasedTime } from '@celito.clients/utils';
import { mergeClasses } from '@fluentui/react-components';
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { formatDate, isValid } from 'date-fns';
import React from 'react';
import { FieldError } from 'react-hook-form';

import { Field } from '../shared';
import { DatePickerProps, IDatePickerStrings } from './date-picker.model';

interface DatePickerViewProps extends DatePickerProps {
  onSelectDateHandler: (date: Date | null | undefined) => void;
  textInputError?: FieldError;
  strings?: IDatePickerStrings;
}

const DatePickerView: React.FC<DatePickerViewProps> = ({
  label = '',
  minDate,
  value,
  maxDate,
  onDateChange,
  onInputChange,
  error,
  textInputError,
  disabled = false,
  stylesProps,
  size = 'large',
  helperLabelText,
  required,
  onSelectDateHandler,
  handleDateChange,
  dataTestId,
  onInputBlur,
  ...rest
}) => {
  const datePickerRef = React.useRef<HTMLInputElement>(null);

  return (
    <Field
      size={size}
      label={label}
      helperTextLabel={helperLabelText}
      required={required}
      validationMessage={textInputError?.message || error?.message}
      validationState={
        textInputError?.message || error?.message ? 'error' : 'none'
      }
      data-testid={`label-${createTestAttribute(label)}`}
    >
      <DatePicker
        className={mergeClasses(stylesProps)}
        data-testid={
          dataTestId ? dataTestId : `date-picker-${createTestAttribute(label)}`
        }
        ref={datePickerRef}
        disabled={disabled}
        showGoToToday={false}
        allowTextInput={rest.allowTextInput ?? true}
        minDate={minDate}
        maxDate={maxDate}
        value={(value as Date) ?? undefined}
        onSelectDate={onSelectDateHandler}
        onChange={onInputChange}
        onBlur={onInputBlur}
        today={getZonedBasedTime(new Date())}
        formatDate={(date) => {
          return date && isValid(date) ? formatDate(date, DateFormat.Date) : '';
        }}
      />
    </Field>
  );
};
export default DatePickerView;
